var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
import React from 'react'
import styled from 'styled-components'
var Circle = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      [
        '\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 134px;\n  height: 134px;\n  border-radius: 67px;\n  object-fit: contain;\n  background-color: #0000004c;\n',
      ],
      [
        '\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 134px;\n  height: 134px;\n  border-radius: 67px;\n  object-fit: contain;\n  background-color: #0000004c;\n',
      ]
    ))
)
var MessageSpan = styled.span(
  templateObject_2 ||
    (templateObject_2 = __makeTemplateObject(
      ['\n  font-size: 12px;\n  font-weight: bold;\n  color: #ffffff;\n'],
      ['\n  font-size: 12px;\n  font-weight: bold;\n  color: #ffffff;\n']
    ))
)
var SpinningImage = styled.img(
  templateObject_3 ||
    (templateObject_3 = __makeTemplateObject(
      [
        '\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  animation: spin 4s linear infinite;\n',
      ],
      [
        '\n  @keyframes spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  animation: spin 4s linear infinite;\n',
      ]
    ))
)
export var BlockingLoadBox = function (props) {
  var show = props.show,
    _a = props.message,
    message = _a === void 0 ? 'Wait..' : _a
  var _b = React.useState(false),
    showContents = _b[0],
    setShowContents = _b[1]
  React.useEffect(
    function () {
      var handler = setTimeout(function () {
        setShowContents(true)
      }, 500)
      return function () {
        return clearTimeout(handler)
      }
    },
    [showContents]
  )
  return React.createElement(
    'div',
    {
      style: {
        visibility: show ? 'visible' : 'hidden',
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        // backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      },
    },
    showContents &&
      React.createElement(
        Circle,
        null,
        React.createElement('div', { style: { height: 14 } }),
        React.createElement(MessageSpan, null, message)
      )
  )
}
var templateObject_1, templateObject_2, templateObject_3
//# sourceMappingURL=BlockingLoadBox.js.map
